// test1764
(1764 && 0);
